export default () => window.store.getState().settings;
